import React, { useEffect, useState } from 'react';
import callAPI from '../../commonservices/APIRequests';
import { usePlaidLink } from 'react-plaid-link';
import { Image, Button } from 'react-bootstrap';
import plaidwhitelogo from '../../assets/images/logo/plaid_white_logo.svg';
import { useNavigate } from 'react-router-dom';

const ReconnectPlaid = (props) => {

  let userDetails = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
  const [linkToken, UpdateToken] = useState('');
  const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};
  const [plaidEnvironment, setEnvironment] = useState(process.env.REACT_APP_ENVIRONMENT === 'production' ? 'production' : 'sandbox');
  const isOAuthRedirect = window.location.href.includes('?oauth_state_id=');
  const navigate = useNavigate();

  useEffect(() => {
    if (isOAuthRedirect) {
      UpdateToken(localStorage.getItem('reconnect_link_token'));
      return;
    }
    if (partnerDetails && partnerDetails.enablePlaid)
      createLinkToken();

  }, []);

  const plaidEventHandler = (event) => {

    if (event === 'OPEN') {
      extendSession(true);
    }
    else if ((event === 'EXIT' || event === 'HANDOFF') && window.location.href.indexOf('oauth') > -1) {
      extendSession();
      if (partnerDetails && partnerDetails.enablePlaid)
        createLinkToken();
      navigate(window.location.pathname, { replace: true });
    }

  }

  const createLinkToken = () => {

    const reqCLT = {
      updateMode: true,
      bankId: props.bankID

    }

    if (props.dealerId)
      reqCLT.dealer_id = props.dealerId;

    callAPI.post('/payment/api/v1/plaid/createLinkToken', reqCLT)
      .then(response => {

        UpdateToken(response.data.plaid.link_token);
        setEnvironment(response.data.plaidEnvironment);
        localStorage.setItem('reconnect_link_token', response.data.plaid.link_token);

      })
      .catch(error => {

        console.log(error)
      });

  }

  const onExit = async (error, metadata) => {
    //await extendSession();
    if (error && props.setplaidFailedStatus) {
      props.setplaidFailedStatus(true)
    }

    const req = {
      metadata: metadata,
      error: error,
      type: 'reconnect'
    }
    callAPI.post('/payment/api/v1/plaid/savePlaidLogs', req);
  }

  const onSuccess = async (token, metadata) => {

    props.setModalLoader(true);

    const req = {
      metadata: metadata,
      error: {},
      type: 'reconnect'
    }

    userDetails.showPlaidBanner = false;
    localStorage.setItem('user', JSON.stringify(userDetails));
    if (props.setPlaidConnectionRequiredStatus) {
      props.setPlaidConnectionRequiredStatus(false);
    }

    callAPI.post('/payment/api/v1/plaid/savePlaidLogs', req);

    await extendSession();
    callAPI.post('/payment/api/v1/plaid/resetBankErrorMessage', { bankId: props.bankID, metadata: metadata })
      .then(response => {
        if (props.updateBanks) {
          props.updateBanks();
        }
      })
      .catch(error => {
        console.log(error)
      });

    await props.updateBanks();
    props.setModalLoader(false);
  }

  const extendSession = (extend45) => {

    //2700 sec = 45 min

    return callAPI.post('/auth/api/v1/auth/keepActive', extend45 ? { customTime: 2700 } : {})
      .then((response) => {

        if (response.status === 200) {



        }
        else {

          console.log(response.message);

        }

      })

  }

  const config = {
    // token must be the same token used for the first initialization of Link
    token: linkToken,
    env: plaidEnvironment,
    onSuccess: onSuccess,
    onEvent: plaidEventHandler,
    onExit: onExit,
    onLoad: extendSession
  };
  if (isOAuthRedirect) {
    // receivedRedirectUri must include the query params
    config.receivedRedirectUri = window.location.href;
    config.token = localStorage.getItem('reconnect_link_token');
  }
  const {
    open,
    ready,
    // error,
    // exit
  } = usePlaidLink(config);

  React.useEffect(() => {
    // If OAuth redirect, instantly open link when it is ready instead of
    // making user click the button
    if (isOAuthRedirect && ready) {
      open();
    }
  }, [ready, open, isOAuthRedirect]);

  return (
    <React.Fragment>

      {isOAuthRedirect ? (
        <></>
      ) : (
        (partnerDetails && partnerDetails.enablePlaid) && !userDetails.readOnlyAccess ?
          <Button className='default-btn reconnect-plaid-btn' onClick={() => open()} disabled={!ready}>
            {props.buttonLabel ? props.buttonLabel : <span>Reconnect to <Image src={plaidwhitelogo} height={14} className='ml-2' /></span>}
          </Button> : null
      )}
    </React.Fragment>
  );
};

export default ReconnectPlaid;